import { render, staticRenderFns } from "./InfoAdjustmentDetail.vue?vue&type=template&id=1068a2b3"
import script from "./InfoAdjustmentDetail.vue?vue&type=script&lang=js"
export * from "./InfoAdjustmentDetail.vue?vue&type=script&lang=js"
import style0 from "./InfoAdjustmentDetail.vue?vue&type=style&index=0&id=1068a2b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports